
const TagReportItem = ({ label, color = 'red', appearence }) => {
	return (
		<div className='flex lg:p-4 2xl:p-5 rounded-lg border border-db items-center'>
			<div className='h-3.5 w-3.5 rounded-full' style={{ backgroundColor: color }}></div>
			<h5 className='lg:ml-4 2xl:ml-5 2xl:text-xl font-bold leading-7 text-1b'>{label}</h5>
			<div className='ml-auto 2xl:text-lg font-normal text-7d'>{appearence} appearences</div>
		</div>
	)
}

export default TagReportItem